import {useNavigate, useSearchParams} from "react-router-dom";
import {DataRequestParams, DataRequestState, DataTable, useDataRequest, useDebouncedFilter} from "../../data";
import FilterTableMandanten, {MandantenFilter} from "./FilterTableMandanten";
import {useMemo} from "react";
import {mandantenStyles} from "../../../styles/mandanten/mandanten.styles";
import {useMandantenHandling} from "../../../hooks/mandanten/useMandantenHandling";
import {Box, Button, capitalize, Paper, Typography} from "@mui/material";
import {Mandant} from "../../../api";
import Layout from "../../Layout";
import {GridColDef} from "@mui/x-data-grid";
import Guard from "../../guards/Guard";
import {permissions} from "../../../permissions";

export default function TableMandanten() {
    const [searchParams] = useSearchParams();
    const {translation, loadMandanten} = useMandantenHandling();
    const navigate = useNavigate();

    const request: DataRequestState<MandantenFilter> = useDataRequest<MandantenFilter>({
        filter: {
            filtered: searchParams.get("filter") ?? "",
            search: searchParams.get("search") ?? "",
        },
    });

    const [{ search }, setField] = useDebouncedFilter(request);

    const filter = useMemo(() => {
        return searchParams.get("filter");
    }, [searchParams]);

    return (
        <Layout>
            <Paper sx={mandantenStyles.tableMandanten.paper}>
                <Box sx={mandantenStyles.tableMandanten.headerBoxWrapper}>
                    <Typography variant="h5">
                        {capitalize(translation('clients'))}
                    </Typography>
                    <Guard
                        permission={permissions.mandanten.create}
                    >
                        <Button
                            variant={"contained"}
                            color={"secondary"}
                            onClick={() => {
                                navigate("/mandanten/new");
                            }}
                        >
                            {capitalize(translation('client-create'))}
                        </Button>
                    </Guard>
                </Box>
                <FilterTableMandanten setField={setField} search={search}/>
                <Box sx={mandantenStyles.tableMandanten.box}>
                    <DataTable<Mandant, MandantenFilter>
                        name="table-mandanten"
                        queryKey={["mandanten"]}
                        loadData={(params: DataRequestParams<MandantenFilter>) => loadMandanten(params, request.filter)}
                        request={request}
                        columns={useColumns()}
                        size="large"
                        initialFilters={filter ? JSON.parse(filter) : undefined}
                        onRowClick={(row) => {
                            navigate(`/mandanten/${row.id}`);
                        }}
                        disableRowSelectionOnClick={true}
                        setField={setField}
                    />
                </Box>
            </Paper>
        </Layout>
    );
}

function useColumns(): Array<GridColDef<Mandant>> {
    const {translation} = useMandantenHandling();

    return useMemo(
        () => [
            {
                field: "id",
                headerName: capitalize(translation("client-attributes-id")),
                flex: 1,
            },
            {
                field: "name",
                headerName: capitalize(translation("client-attributes-name")),
                flex: 1,
            },
            {
                field: "beschreibung",
                headerName: capitalize(translation("client-attributes-description")),
                flex: 1,
            },
        ],
        [translation]
    );
}
